<template>
  <v-sheet color="bg1" :class="dashboardClass" ref="taskChartsContainer" id="task-charts-container">
    <v-row class="pa-5 pb-2">
      <v-col cols="4">
        <v-card style="height: 300px;" class="d-flex justify-center ">
          <div v-if="series.length" ref="pieChartWrapper" class="w-100 d-flex justify-center">
            <apex-charts  ref="chart" :width="pieChartSize.width" :height="pieChartSize.height"
              :key="key" type="pie" :options="pieOptions" :series="series">
            </apex-charts>
          </div>
          <div v-if="!series.length" class="no-data">
                     <span>
No Data to display !
            </span>
          </div>
        </v-card>
      </v-col>
      <v-col cols="8">
        <v-card style="height: 300px;" class="d-flex justify-center">
          <div v-if="barSeries.length" ref="barChartWrapper" class="bar-chart-wrapper w-100 d-flex justify-center">
            <apex-charts   :width="barChartSize.width" :height="barChartSize.height" :key="key"
              type="bar" :options="barOptions" :series="barSeries">
            </apex-charts>
          </div>

          <div v-if="!barSeries.length" class="no-data">
                       <span>
No Data to display !
            </span>
          </div>
        </v-card>

      </v-col>
    </v-row>
    <v-row class="pa-5 pt-2">
      <v-col cols="12">
        <v-card style="height: 40vh;" class="d-flex justify-center">
          <div  v-if="timelineSeries.length " ref="timelineChartWrapper" class=" w-100 d-flex justify-center pt-5">
            <apex-charts :width="timelineChartSize.width" :height="timelineChartSize.height" v-if="series.length"
              :key="key"   :options="timelineOptions" :series="timelineSeries">
            </apex-charts>
          </div>

          <div v-if="!timelineSeries.length" class="no-data">
            <span>
No Data to display !
            </span>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import ganttService from '../service/gantt.service';

export default {
  name: 'app-task-board-charts',
  data() {
    return {
      taskSeries: [],
      series: [],
      key: 0,
      barSeries: [],
      timeLinesColors: [],
      timeLinesWidths: [],
      timelineSeries: [],
      pieChartSize: {
        width: 300,
        height: 300
      },
      barChartSize: {
        width: 300,
        height: 300
      },
      timelineChartSize: {
        width: 300,
        height: 300
      },
      chartsLoading: false,
      timelineLoading: false,
    }
  },
  mounted() {
    this.getData();

    const myDiv = document.getElementById('task-charts-container');
    var self = this;
    const resizeObserver = new ResizeObserver(() => {
      self.setSize();
    });

    resizeObserver.observe(myDiv);
    // setTimeout(()=>{
    //   self.setSize();
    // },100)
  },
  methods: {
   setSize(){
    var self=this;
    if (self.$refs.pieChartWrapper
     && self.$refs.pieChartWrapper.clientWidth
     &&self.$refs.pieChartWrapper.clientHeight) {
    var min=Math.min(self.$refs.pieChartWrapper.clientWidth, self.$refs.pieChartWrapper.clientHeight);
    
      console.log("Pie-chart",min);
          self.pieChartSize.width = min-10;
          self.pieChartSize.height = min-20;
        }

       if (self.$refs.barChartWrapper 
       &&self.$refs.barChartWrapper.clientWidth   
       &&self.$refs.barChartWrapper.clientHeight

      ) {

        console.log("bar-chart", { w: self.$refs.barChartWrapper.clientWidth, h: self.$refs.barChartWrapper.clientHeight });
        self.barChartSize.width = self.$refs.barChartWrapper.clientWidth - 50;
        self.barChartSize.height = self.$refs.barChartWrapper.clientHeight;
      }
      if (self.$refs.timelineChartWrapper) {

        self.timelineChartSize.width = self.$refs.timelineChartWrapper.clientWidth - 100;
        self.timelineChartSize.height = self.$refs.timelineChartWrapper.clientHeight - 20;
      }
   },
    showTasksOn3d(tasks) {
      
      this.$store.commit('SET_VIEWER_TYPE', '3d');
      this.$store.commit('SET_TASK_VIEWER_COLORING_OPTION', 'status');
      this.$emit('showIn3d', tasks);
    },
    getData() {
      this.chartsLoading = true;
      this.timelineLoading = true;
      var options = structuredClone(this.options);
      options.typeId = this.$route.params.taskTypeId;
      ganttService.charts(options).then(res => {
        this.taskSeries = res.data;
        var series = this.taskSeries.map(e => e.value || e.Value);
        this.series = series;
        
        if(this.series.length){
          this.barSeries = [{ data: series.map(val => Math.log(val + 1))}];
        }
      else{
         this.barSeries = [];
      }
 
      })
        .finally(() => {
          this.chartsLoading = false;
          this.setSize();
        });
      ganttService.timeline(options).then(res => {
       
        if (res.data.length) {
          this.timelineSeries = this.convertTaskSeries(res.data);
          
          var completedTasks=this.timelineSeries.find(e=>e.statusType=="Done");
          if(completedTasks){
      const burnup = this.generateBurnupSeries(completedTasks.data);
            this.timelineSeries.push( {
          name: "Completed (Cumulative)",
          type: "line",
          data: burnup,
          color :'#00C853',
          width:3
        })

   

          }
      
        } else {
          this.timelineSeries = []
        }
        this.timeLinesColors = res.data.map(e => e.color);
        this.timeLinesWidths = this.timelineSeries.map(e => e.width);
        this.timelineSeries = this.timelineSeries.map(s => ({ ...s, yAxis: s.type === 'line' ? 1 : 0 }));
      })
        .finally(() => {
          this.timelineLoading = false;
           this.setSize();
        });

      setTimeout(() => {
        this.key = Date.now()
      }, 100)
    },
    generateBurnupSeries(data) {
  // Sort by timestamp in ascending order
  const sorted = data.slice().sort((a, b) => a[0] - b[0]);
  const cumulative = [];
  let total = 0;
  for (let i = 0; i < sorted.length; i++) {
    const [timestamp, count] = sorted[i];
    total += count;
    // Push [timestamp, cumulative_total]
    cumulative.push([timestamp, total]);
  }
  return cumulative;
    },
    convertTaskSeries(rawSeries) {
      return rawSeries.map(series => {
        // Make a map to sum counts per unique date
        const dateMap = {};

        series.data.forEach(item => {
          const time = item.time.slice(0, 10); // get YYYY-MM-DD only
          if (!dateMap[time]) {
            dateMap[time] = 0;
          }
          dateMap[time] += item.count;
        });

        // Convert map to sorted [timestamp, total] pairs
        const data = Object.keys(dateMap)
          .sort() // sort by date
          .map(dateStr => {
            const timestamp = new Date(dateStr).getTime();
            return [timestamp, dateMap[dateStr]];
          });

        return {
          name: series.name,
          statusType:series.statusType,
          data: data,
          type:'column',
          width:0
        }; 
      });
    },
    onLegendClick(event, chartContext, config) {
      
      var statusName = this.taskSeries[config.dataPointIndex]?.name;
      this.getTasksByStatusName(statusName);
    },
    onTimelineMarkerClick(event, chartContext, config) {
       
      var statusName = this.timelineSeries[config.dataPointIndex]?.name;
    this.getTasksByStatusName(statusName);
    },
     onTimelineLegendClick(chartContext, seriesIndex) {
      var statusName = this.timelineSeries[seriesIndex]?.name;
      this.getTasksByStatusName(statusName);
    },
    getTasksByStatusName(statusName){
         var status = this.currentTaskType.statuses.find(e => e.name == statusName);
      if (!status)
        return;
      var options = structuredClone(this.options)
      options.statusId = status.id;
      options.typeId = this.$route.params.taskTypeId;
      

      ganttService.get(options).then(res => {
        
        var tasks = res.data.items;
        this.showTasksOn3d(tasks);
      })
    },
   
  },
  computed: {
    currentTaskType() {
      return this.$store.getters['TASK_MANAGER/GET_CURRENT_TASK_TYPE'];
    },
    options: {
      get() {
        return this.$store.getters['TASK/GET_OPTIONS'];
      },
      set(val) {
        this.$store.commit('TASK/SET_OPTIONS', val);
      },
    },

    pieOptions() {

      var data = this.taskSeries;
      var labels = data.map(e => `${e.name || e.Name}`?.trim() == null ? 'Unset' : e.name || e.Name);

      var colors = data.map(e => e.color || e.Color);
      var options = {
        chart: {
          type: 'pie',
          events: {
            dataPointSelection: this.onLegendClick.bind(this)
          }
        }
        ,
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '10px'
          },
          formatter: function (val, opts) {
            const series = opts.w.config.series;
            const total = series.reduce((sum, val) => sum + val, 0);
            const count = series[opts.seriesIndex];
            const percent = val.toFixed(0); // optional: round percentage
            return `${percent}% (${count}/${total})`;
          }
        },
   plotOptions: {
    pie: {
      expandOnClick: true,
      donut: {
        size: '65%', // adjust as needed
        labels: {
          show: false // prevent overlapping with custom data labels
        }
      },
      dataLabels: {
        offset: -20
      }
    }
  },
        colors: colors,
        labels: labels,
        legend:{
          show:false
        }
      };

      return options;
    },
    barOptions() {
      var data = this.taskSeries;
      var labels = data.map(e => `${e.name || e.Name}`?.trim() == null ? 'Unset' : e.name || e.Name);

      var colors = data.map(e => e.color || e.Color);
      var options = {
        chart: {
          type: 'bar',
          events: {
            dataPointSelection: this.onLegendClick.bind(this)
          }
        },
          dataLabels: {
          enabled: true,
          style: {
            fontSize: '10px'
          },
            formatter: function (val, opts) {
      var total = this.series.reduce((sum, v) => sum +v, 0);
        val=this.series[opts.dataPointIndex];
      const percent = ((val / total) * 100).toFixed(0);
      return `${percent}% (${val}/${total})`;
    }.bind(this),
        },
        fill: {
          colors
        },
          yaxis: {

      title: {
        text: 'Tasks'
      },
       labels: {
    formatter: (val) => `${Math.round(Math.exp(val))}`
  },
      min: 0,
    },
        colors: colors,
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 5,
            borderRadiusApplication: 'end',
            distributed: true
          },
        },
        xaxis: {
          categories: labels
        }
      }

      return options;
    },
   timelineOptions() {
      // Calculate min/max for each y-axis
      const barSeries = this.timelineSeries.filter(s => (s.yAxis === 0 || (!('yAxis' in s) && s.type !== 'line')));
      const lineSeries = this.timelineSeries.filter(s => s.yAxis === 1 || s.type === 'line');
      const getMinMax = seriesArr => {
        if (!seriesArr.length) return { min: 0, max: 1 };
        const allVals = seriesArr.flatMap(s => s.data.map(d => d[1]));
        const min = Math.floor(Math.min(...allVals));
        const max = Math.ceil(Math.max(...allVals));
        return { min, max: max === min ? min + 1 : max };
      };
      const barMinMax = getMinMax(barSeries);
      const lineMinMax = getMinMax(lineSeries);
      return {
        chart: {
          type: 'line',
          stacked: false,
          events: {
            legendClick: this.onTimelineLegendClick.bind(this),
            markerClick: this.onTimelineMarkerClick.bind(this),
          }
        },
        // dataLabels: {
        //       enabled: false
        //     },
        plotOptions: {
          bar: {
            columnWidth: '100%',
            borderRadius: 2,
            borderRadiusApplication: 'end',
            distributed: false,
          },
        },
        colors: this.timeLinesColors,
        stroke: {
          width: this.timeLinesWidths,
          dashArray: this.timeLinesWidths.map(e => e * 2),
          colors: this.timeLinesColors
        },
        xaxis: {
          type: 'datetime',
          title: { text: 'Date' },
        },
        yaxis: [
          {
            title: { text: 'Tasks Status' },
            min: barMinMax.min,
            max: barMinMax.max,
           
          },
          {
            opposite: true,
            title: { text: 'Completed Tasks (Cumulative)' },
            min: lineMinMax.min,
            max: lineMinMax.max,
            forceNiceScale: true,
          
          },
        ],
        markers: {
          size: 4
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          show: true,
          onItemClick: {
            toggleDataSeries: true,
          },

        },
        tooltip: {
          shared: true,
          x: {
            format: 'dd MMM yyyy'
          }
        }
      };
    },

    dashboardClass() {
      let dashboardClass = 'inspection-dashboard-space ';
      dashboardClass += this.isDarkModeOn ? 'dark-theme ' : '';
      return dashboardClass;
    },
  }, watch: {
    options() {
      this.getData();
    },

  },
  activated(){
   this.getData();
  }
}
</script>

<style>
.pie-chart-wrapper {}
.no-data{
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
}
</style>